'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../node_modules/@fortawesome/pro-solid-svg-icons/index.cjs');
var React = require('react');
var reactFontawesome = require('../../../react-fontawesome/react-fontawesome.cjs');
var InternalCheckbox_web_styles = require('./InternalCheckbox.web.styles.cjs');

/**
 * Styled checkbox, used for form inputs
 *
 * @scope Core
 *
 */ const InternalCheckbox = ({ children, disabled, id, isFullWidth = false, labelStyle, indeterminate = false, ...rest })=>{
    const checkboxRef = React.useRef(null);
    React.useEffect(()=>{
        if (checkboxRef.current) checkboxRef.current.indeterminate = indeterminate;
    }, [
        indeterminate
    ]);
    const wrapperStyles = [
        InternalCheckbox_web_styles.checkbox.base,
        isFullWidth && InternalCheckbox_web_styles.checkbox.isFullWidth,
        labelStyle
    ];
    const iconContainerStyles = [
        InternalCheckbox_web_styles.iconContainer.base,
        disabled && InternalCheckbox_web_styles.iconContainer.disabled
    ];
    return /*#__PURE__*/ jsxRuntime.jsxs("label", {
        htmlFor: id,
        css: wrapperStyles,
        "aria-disabled": disabled,
        "data-testid": "aviary-checkbox-label",
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("input", {
                id: id,
                css: InternalCheckbox_web_styles.checkboxInput,
                type: "checkbox",
                disabled: disabled,
                ref: checkboxRef,
                "aria-checked": indeterminate ? "mixed" : rest.checked,
                ...rest
            }),
            /*#__PURE__*/ jsxRuntime.jsx("div", {
                css: iconContainerStyles,
                children: /*#__PURE__*/ jsxRuntime.jsx(reactFontawesome.FontAwesomeIcon, {
                    css: InternalCheckbox_web_styles.icon,
                    icon: indeterminate ? index.faMinus : index.faCheck
                })
            }),
            !!children && /*#__PURE__*/ jsxRuntime.jsx("div", {
                css: InternalCheckbox_web_styles.checkboxContent,
                children: children
            })
        ]
    });
};

exports.InternalCheckbox = InternalCheckbox;
//# sourceMappingURL=InternalCheckbox.web.cjs.map
